import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../store/settings/user/service/user.service';
import { AppNav } from './app-enum';

/**
 * Global handler for expired/invalid sessions. When the API responds 401, the
 * stored session is cleared and the user is redirected to login. This runs
 * before each request's own catchError, so an expired token can't silently
 * serve stale cached data (see HttpService.get).
 */
export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const userService = inject(UserService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        userService.clearSession();
        router.navigate([AppNav.login]);
      }
      return throwError(() => error);
    }),
  );
};
